module.exports = __webpack_public_path__ + "static/media/beer.46ca09a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/beer.svg
// module id = 304
// module chunks = 0